import httpClient from "Api/httpClient";

const END_POINT = "/bills";

const getBills = (payload) => {
    let body = "";
    if (payload.body) body = payload.body;
    return httpClient.get(END_POINT, { retryTimes: 3, params: body }); // useCahe: true, retryTimes: 3, throttle: true
};

const getBill = (bill_id) => {
    if (!bill_id) return;
    const SINGLE_END_POINT = END_POINT + "/" + bill_id;
    return httpClient.get(SINGLE_END_POINT);
};

const printBill = (bill_id, view_as = null) => {
    if (!bill_id) return;
    const SINGLE_END_POINT = END_POINT + "/print?bill_id=" + bill_id + "&view_as=" + view_as;
    return httpClient.get(SINGLE_END_POINT);
};

const createBills = (payload) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    return httpClient.post(END_POINT, body);
};

const updateBills = (payload, bill_id) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    const UPDATE_END_POINT = END_POINT + "/" + bill_id;
    return httpClient.patch(UPDATE_END_POINT, body);
};

const deleteBills = (bill_id) => {
    const DELETE_END_POINT = END_POINT + "/" + bill_id;
    return httpClient.delete(DELETE_END_POINT, { retryTimes: 3 });
};

export { getBills, getBill, printBill, createBills, updateBills, deleteBills };
